import { SavedAirResponseDataDTO } from "./response.types";
import { AirAirlineNameDTO, AirReferenceDTO, AirStatusesModel } from "entities/shared/airCard.types";
import { CoordinateModelDTO } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { t } from "shared/localization/localization";
import { parseAirCargo } from "./cargo";
import { piecesText } from "./utils";

export class SavedAirResponseParser {
  constructor(private model: SavedAirResponseDataDTO) {}

  get id(): number {
    return this.model.id;
  }

  get pieces(): string {
    const cargo = parseAirCargo(this.model.size_type);
    const piece = this.model.equipments_count || cargo.pieces;
    const weight = cargo.weight;
    if (piece && weight) {
      return `${piecesText(piece)} / ${weight} ${t("kg")}`;
    }
    if (piece) {
      return piecesText(piece);
    }
    if (weight) {
      return `${weight} ${t("kg")}`;
    }
    return "";
  }

  get airlineName(): string {
    return this.model.carrier_name ?? "";
  }

  get reference(): AirReferenceDTO | null {
    return this.model.reference ?? null;
  }

  get fromDirection(): string | null {
    return this.model?.location?.from ?? null;
  }

  get toDirection(): string | null {
    return this.model?.location?.to ?? null;
  }

  get portNames(): { to: string | null; from: string | null } {
    return {
      to: this.toDirection,
      from: this.fromDirection,
    };
  }

  get status(): ValueOf<typeof AirStatusesModel> {
    return this.model.status || AirStatusesModel.UNKNOWN;
  }

  get carrierName(): AirAirlineNameDTO | null {
    return this.model.carrier_name;
  }

  get carrierScac(): AirAirlineNameDTO | null {
    return this.model.carrier_scac;
  }

  get podCoordinate(): CoordinateModelDTO | null {
    return this.model?.location?.pin ?? null;
  }

  get updatedAt(): string {
    return this.model.updated_at;
  }

  get currentPin(): CoordinateModelDTO | null {
    return this.model.location?.pin ?? null;
  }

  get atd(): string | null {
    return this.model.date.from_actual === true && this.model.date.from ? this.model.date.from : null;
  }

  get etd(): string | null {
    return this.model.date.from_actual === false && this.model.date.from ? this.model.date.from : null;
  }

  get ata(): string | null {
    return this.model.date.to_actual === true && this.model.date.to ? this.model.date.to : null;
  }

  get eta(): string | null {
    return this.model.date.to_actual === false && this.model.date.to ? this.model.date.to : null;
  }

  get tags(): string[] {
    return this.model.tags;
  }
}
